import React, {ReactElement} from "react";
import {Box, Button, styled, Typography} from "@mui/material";
import {IFooterElement} from "../../interfaces/components/footers/IFooterElement";
import useRedirect from "../../routing/useRedirect";
import Grid from "@mui/material/Grid";

const Root = styled(Grid)(({theme}) => ({
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    minHeight: 64,
    justifyContent: 'space-evenly',
    alignItems: 'center',
}));

interface IProps {
    footerElements: IFooterElement[],
}

function Footer({footerElements}: IProps): ReactElement {
    const redirect = useRedirect();

    return (
        <Root>
            {footerElements.map((element, i) =>
                <Button
                    aria-label={element.name}
                    variant={'text'}
                    key={element.name + i}
                    onClick={() => redirect(element.link)}
                    sx={{maxHeight: 40}}
                >
                    <Typography
                        variant={"h5"}
                        color={"textSecondary"}
                    >
                        {element.name}
                    </Typography>
                </Button>
            )}
        </Root>
    );
}

export default Footer;
